module.exports = __webpack_public_path__ + "static/img/behavioural.62ef874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/behavioural.svg
// module id = ezFs
// module chunks = 1